<script>
export default {
  model: {
    prop: 'modelValue',
    event: 'change',
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    modelValue: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    showInfo: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    shouldBeChecked () {
      return this.modelValue === this.value
    },
  },
  methods: {
    updateInput () {
      this.$emit('change', this.value)
    },
    decodeHTMLEntities (str) {
      let element = document.createElement('div')
      if (str && typeof str === 'string') {
        // strip script/html tags
        str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, '')
        str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, '')
        element.innerHTML = str
        str = element.textContent
        element.textContent = ''
      }
      return str
    },
    showModal () {
      this.$emit('showModalInfo')
    }
  },
}
</script>

<template>
  <label :class="$style.label">
    <div :class="$style.content">
      {{ decodeHTMLEntities(label) }}
      <img
        v-if="showInfo"
        :class="$style.infoImage"
        src="@assets/images/infoCircle.png"
        @click="showModal"
      >
    </div>
    <input
      :checked="shouldBeChecked"
      :value="value"
      :class="$style.radio"
      type="radio"
      @change="updateInput"
    >
  </label>
</template>

<style lang="scss" module scoped>
@import '@design';

.radio {
  vertical-align: text-top;
}

.label {
  margin: 0;
  font-size: 1rem;
}

.content {
  display: inline;
}

.infoImage {
  max-height: 1.4rem;
  max-width: 1.4rem;
}

input[type='radio'] {
  position: relative;
  display: inline-block;
  min-width: 1.5rem;
  height: 1.5rem;
  margin: 0;
  cursor: pointer;
  border: 2px solid $color-text;
  border-radius: 50%;
  -webkit-appearance: none;

  &::after {
    position: relative;
    top: 17%;
    display: block;
    margin: 0 auto;
    width: 0.8rem;
    height: 0.8rem;
    content: '';
    border-radius: 25px;
  }

  &:checked {
    border: 2px solid $options-color;
    &::after {
      background-color: $options-color;
    }
  }

  &:focus {
    outline: none;
  }
}
</style>
